import React, { useEffect, useState } from 'react';
import { StyledCardsContainer } from '../../VoucherAppointments/VoucherAppointmentsStyle';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  loadMyChildrenList,
  loadMyChildrenDataReport,
  resetChildDataReport,
  loadHistoryDataReport,
  myReportsModule,
  loadChildDdoDataReport,
  resetHistoryDataReport
} from '../MyReportsDucks';
import { FormControl, InputLabel, Select, MenuItem } from '@material-ui/core';
import moment from 'moment';
import StaticTablePaginated from '../../../_ui/Table/StaticTablePaginated';

import { MyReportsHistoryColumns } from './MyReportsHistoryColumns';
import MyReportsHistoryDialog from './MyReportsAttendanceHistoryDialog';
import { getDdoPeriodSuffix } from '../MyReportsUtils';
// import useTableFilter from '../../../components/TableFilter/useTableFilter';

const MyReportsHistory = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const {
    data,
    childDataReport,
    historyDataReport,
    childDdoData,
    loading,
    historyTotalElements,
    historyPageNumber
  } = useSelector(state => state[myReportsModule]);
  const [selectedChild, setSelectedChild] = useState('');
  const [selectedKindergarten, setSelectedKindergarten] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogData, setDialogData] = useState(null);
  const [historyFilter, setHistoryFilter] = useState({ pageNumber: 1, pageSize: 10 });

  const loadData = filter => {
    dispatch(loadHistoryDataReport(filter));
  };

  // const { toPage } = useTableFilter(loadData, '', {
  //   pageNumber: 1,
  //   pageSize: 2
  // });

  useEffect(() => {
    dispatch(loadMyChildrenList());
    dispatch(resetHistoryDataReport());
  }, [dispatch]);

  const handleChildChange = event => {
    const iin = event.target.value;
    setSelectedChild(iin);
    setSelectedChild(iin);
    setSelectedKindergarten('');

    if (iin) {
      dispatch(resetChildDataReport());
      dispatch(resetHistoryDataReport());

      const filterParams = {
        iin: iin
      };

      dispatch(loadChildDdoDataReport(filterParams));
    }
  };

  const handleKindergartenChange = event => {
    // значение — id записи контингента (уникален для каждого периода зачисления),
    // а не serviceProviderId: при перезачислении в тот же сад id-провайдера совпадают
    const childRecordId = event.target.value;
    setSelectedKindergarten(childRecordId);
    if (!selectedChild || !childRecordId) return;

    const selectedKindergartenData = childDdoData.find(
      item => item.id === childRecordId
    );
    if (!selectedKindergartenData) return;

    const filterParams = {
      pageNumber: 1,
      pageSize: 10,
      childId: selectedKindergartenData.id,
      childIin: selectedChild,
      dateMin: selectedKindergartenData.enrolledDate
        ? moment(selectedKindergartenData.enrolledDate).format('YYYY-MM-DD')
        : null,
      dateMax: selectedKindergartenData.expelledDate
        ? moment(selectedKindergartenData.expelledDate).format('YYYY-MM-DD')
        : moment().format('YYYY-MM-DD')
    };

    setHistoryFilter(filterParams);
    loadData(filterParams);
  };


  const handleViewReport = row => {
    if (!selectedKindergarten) return;

    const selectedKindergartenData = childDdoData.find(
      item => item.id === selectedKindergarten
    );
    if (!selectedKindergartenData) return;

    const dateMin = moment(row.decisionMonth).format('YYYY-MM-DD');
    const dateMax = moment(row.decisionMonth)
      .endOf('month')
      .format('YYYY-MM-DD');

    const filterParams = {
      pageNumber: 1,
      pageSize: 10,
      forQrRuntime: true,
      dateMin,
      dateMax,
      childId: selectedKindergartenData.id
    };

    dispatch(loadMyChildrenDataReport(filterParams));
    setDialogData({
      decisionMonth: row.decisionMonth,
      visitsInfo: []
    });
    setOpenDialog(true);
  };

  useEffect(() => {
    if (
      Array.isArray(childDataReport) &&
      childDataReport.length > 0 &&
      Array.isArray(childDataReport[0].visitsInfo)
    ) {
      setDialogData(prev => ({
        ...prev,
        visitsInfo: childDataReport[0].visitsInfo
      }));
    }
  }, [childDataReport]);

  return (
    <StyledCardsContainer>
      <div className="mt3">
        <h2>{t('myReportsHistory_title')}</h2>
      </div>

      <div style={{ display: 'flex', gap: '20px', width: '100%', flexWrap: 'wrap' }}>
        <FormControl variant="outlined" style={{ marginBottom: '20px', minWidth: 200 }}>
          <InputLabel id="child-select-label">{t('myReports_myChildren')}</InputLabel>
          <Select
            labelId="child-select-label"
            value={selectedChild}
            onChange={handleChildChange}
            label={t('myReports_myChildren')}
          >
            {data.length > 0 &&
              data.map(child => (
                <MenuItem key={child.iin} value={child.iin}>
                  {child.firstname} {child.lastname}
                </MenuItem>
              ))}
          </Select>
        </FormControl>

        <FormControl variant="outlined" style={{ marginBottom: '20px', minWidth: 250 }}>
          <InputLabel id="kindergarten-select-label">{t('myReports_ddo')}</InputLabel>
          <Select
            labelId="kindergarten-select-label"
            value={selectedKindergarten}
            onChange={handleKindergartenChange}
            label={t('myReports_ddo')}
          >
            {childDdoData?.length > 0 &&
              childDdoData.map(k => (
                <MenuItem key={k.id} value={k.id}>
                  {i18n.language === 'kk'
                    ? k.serviceProviderKkName
                    : k.serviceProviderRuName}
                  {getDdoPeriodSuffix(k, childDdoData)}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </div>
      <div className="mt2">
        <StaticTablePaginated
          pageNumber={historyPageNumber}
          pageSize={3}
          loading={loading}
          data={historyDataReport || []}
          totalElements={historyTotalElements}
          columns={MyReportsHistoryColumns({
            lang: i18n.language,
            onViewReportClick: handleViewReport
          })}
          filterable={false}
          pagePagination={page => {
            if (page !== historyFilter.pageNumber) {
              const newFilter = { ...historyFilter, pageNumber: page };
              setHistoryFilter(newFilter);
              loadData(newFilter);
            }
          }}
        />
      </div>
      <MyReportsHistoryDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        visitsInfo={dialogData?.visitsInfo || []}
        decisionMonth={dialogData?.decisionMonth}
      />
    </StyledCardsContainer>
  );
};

export default MyReportsHistory;
